module.exports = ".butonAcition {\n  position: absolute;\n  top: 15%;\n  left: 15%; }\n"